import { z } from "zod";

// ─── Plan Limits ────────────────────────────────────────────────────────────

export const planLimitsSchema = z.object({
  connections: z.number().int(), // -1 = unlimited
  groups: z.number().int(),
  appsPerGroup: z.number().int(),
  jobsPerMonth: z.number().int(),
  analysesPerMonth: z.number().int().default(0),
  qvdAnalysesPerMonth: z.number().int().default(0),
  members: z.number().int(),
});
export type PlanLimits = z.infer<typeof planLimitsSchema>;

// ─── Billing Plan ────────────────────────────────────────────────────────────

export const billingPlanSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().optional(),
  description: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  isActive: z.boolean().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type BillingPlan = z.infer<typeof billingPlanSchema> & {
  limits: PlanLimits;
};

// ─── Subscription ────────────────────────────────────────────────────────────

// A plan assigned to an organization by the super-admin. Only `active` grants
// access; any other status reads as "no plan assigned".
export const subscriptionSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  planId: z.string(),
  status: z.string(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
});
export type Subscription = z.infer<typeof subscriptionSchema>;
